var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"inner-content"},[_c('section-marche-promotion-immobiliere',{attrs:{"index":_vm.calc_index + 2,"theme":"marche_promotion_immobiliere","main_color":"dark_blue"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }